export default "__VITE_ASSET__C9ofCTc6__"